define("powergen/controllers/application",
  [],
  function() {
    "use strict";
    var ApplicationController;

    ApplicationController = Ember.ObjectController.extend({
      actions: {
        viewDidClick: function(e) {
          return this.resetTimer();
        }
      },
      timer: null,
      startTimer: function() {},
      stopTimer: function() {
        return Ember.run.cancel(this.get('timer'));
      },
      resetTimer: function() {
        this.stopTimer();
        return this.startTimer();
      }
    });


    return ApplicationController;
  });